import React from "react";
import { ArrowUpRight, CalendarDays } from "lucide-react";
import SectionNumber from "./SectionNumber";
import { EVENTS } from "../lib/data";

/**
 * Reusable "Közelgő esemény" section for subpages.
 * Renders the next event from the EVENTS data array as a wide feature card.
 */
export default function UpcomingEvents({ sectionN = "05", bg = "bg-pkbeige" }) {
  const ev = EVENTS[0];
  if (!ev) return null;

  return (
    <section
      data-testid="upcoming-events"
      className={`relative ${bg} py-24 sm:py-32 overflow-hidden`}
    >
      <SectionNumber n={sectionN} />
      <div className="max-w-6xl mx-auto px-5 sm:px-8 relative">
        <div className="max-w-2xl mb-14 reveal">
          <span className="eyebrow">Csatlakozz hozzánk</span>
          <h2 className="font-serif text-pkcharcoal text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
            Közelgő<br />
            <span className="italic text-pkred">esemény.</span>
          </h2>
        </div>

        <article
          data-testid="upcoming-event-card"
          className="group grid md:grid-cols-2 overflow-hidden bg-white card-fire reveal"
        >
          <div className="relative aspect-[4/3] md:aspect-auto md:min-h-[360px] overflow-hidden">
            <img
              src={ev.img}
              alt={ev.name}
              className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-1000"
            />
            <div className="absolute top-5 left-5 date-badge">{ev.short}</div>
          </div>
          <div className="p-8 sm:p-10 lg:p-12 flex flex-col justify-center">
            <div className="text-pkred text-[0.7rem] tracking-[0.28em] uppercase font-semibold flex items-center gap-2">
              <CalendarDays className="w-4 h-4" strokeWidth={1.8} />
              {ev.date}
            </div>
            <h3 className="font-serif text-3xl sm:text-4xl text-pkcharcoal leading-tight mt-4">
              {ev.name}
            </h3>
            <p className="text-pkcharcoal/70 text-base mt-5 leading-relaxed">
              {ev.desc}
            </p>
            <p className="text-pkred text-sm font-medium mt-5">{ev.note}</p>
            <a
              href={ev.reservationHref}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="upcoming-cta"
              className="btn-fire mt-8 self-start inline-flex items-center gap-2"
            >
              Foglalás
              <ArrowUpRight className="w-4 h-4" strokeWidth={2} />
            </a>
          </div>
        </article>
      </div>
    </section>
  );
}
